import { useMemo } from "react";
import { Outlet, useParams, useLocation, Navigate } from "react-router-dom";
import { LangProvider } from "./i18n/context";
import { getDict, isLangCode, DEFAULT_LANG } from "./i18n";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ClinicSchema from "./components/ClinicSchema";
import { AiraWidget } from "../components/aira/AiraWidget";

export default function DentalLayout() {
  const { lang } = useParams();
  const location = useLocation();
  const valid = isLangCode(lang);
  const activeLang = valid ? lang : DEFAULT_LANG;
  const dict = getDict(activeLang);
  const path = useMemo(
    () => location.pathname.replace(new RegExp(`^/dental/${activeLang}`), "") || "/",
    [location.pathname, activeLang]
  );
  const value = useMemo(() => ({ lang: activeLang, t: dict, path }), [activeLang, dict, path]);

  if (!valid) {
    return <Navigate to={`/dental/${DEFAULT_LANG}`} replace />;
  }

  return (
    <LangProvider value={value}>
      <div className="flex min-h-screen flex-col" data-testid="dental-layout">
        <ClinicSchema />
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <AiraWidget />
      </div>
    </LangProvider>
  );
}
